@if (!isLoggedIn || authError) {
  <div
    class="flex h-screen w-screen flex-wrap content-center justify-center p-5 text-center">
    <div class="flex flex-col items-center gap-12">
      @if (authError) {
        <mat-error class="font-bold">
          Authentication is not available. Please retry in 1 minute
        </mat-error>
      }
      <img class="w-[200px]" src="../../../assets/logo.svg" alt="Logo" />
      <div class="flex flex-col gap-2">
        @for (item of infoButtons; track item; let index = $index) {
          <button mat-flat-button (click)="item.logIn()">
            {{ item.title | translate | uppercase }}
          </button>
          @if (index !== infoButtons.length - 1) {
            <div class="text-[12px]">
              {{ 'loginOr' | translate }}
            </div>
          }
        }
      </div>
    </div>
  </div>
}
